enum SitePermissionTypes {
  A = 'Administrator',
  U = 'User',
}

export default SitePermissionTypes;
